export default __webpack_public_path__ + "static/media/Receipt.7bef160e.pdf";